import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ReactComponent as LinkTo } from '../../../assets/svg/LinkTo.svg';
import { toMplatDate } from '../../../components/common';
import Button from '../../../components/mplat/Button/Button';
import { PromoUnitContent } from '../../../services/content_v1';
import { PROMO_CATEGORIES } from '../../Promo/components/PromoList';

interface PromoItemProps {
    item: PromoUnitContent,
}

export function PromotionItem({ item }: PromoItemProps) {
    // const lang = useLanguage();

    return (
        <article
            className="welcome-sale__item"
            // onClick={() => location.pathname = `/${lang}/public-promo/${item.id}_${translit1(item.title) || '_'}/`}
            onClick={() => location.pathname = `/public-promo/${item.id}`}
        >
            <h3 className="welcome-sale__item-heading">
                {item.summary}
            </h3>
            {/* <h3 className="welcome-sale__item-heading">
                {item.title}
            </h3>
            <p className="welcome-sale__item-copy">
                {item.summary}
            </p> */}
            <ul className="welcome-sale__item-tags">
                <li><Trans>until</Trans>&nbsp;{item.promodates_till ? toMplatDate(item.promodates_till, true) : toMplatDate(item.finish_at, true)}</li>
                {item.tags.map((tg) => <li key={tg}><Trans>{PROMO_CATEGORIES[tg]}</Trans></li>)}
            </ul>
            <p className="welcome-sale__item-cta">
                <Button><Trans>Take part</Trans></Button>
            </p>
        </article>
    )
}

interface WelcomePromotionsProps {
    promo: PromoUnitContent[],
}

function WelcomePromotions({ promo }: WelcomePromotionsProps) {
    // const { user } = useAuth();
    // const lang = useLanguage();

    return (promo.length || 0) > 0 && (
        <section className="welcome-sale">
            <header className="welcome-header">
                <h2 className="welcome-header__heading">
                    {/* <a href={`/${lang}/public-promo`}>
                        <Trans>cms:PROMO</Trans>
                        <LinkTo />
                    </a> */}
                    <Link to="/public-promo">
                        <Trans>cms:PROMO</Trans>
                        <LinkTo />
                    </Link>
                </h2>
                <div className="welcome-header__link">
                    {/* <a href={`/${lang}/public-promo`}>
                        <Trans>See all</Trans>
                        <LinkTo />
                    </a> */}
                    <Link to="/public-promo">
                        <Trans>See all</Trans>
                        <LinkTo />
                    </Link>
                </div>
            </header>
            <div className="welcome-sale__list">
                {promo.map((item) => (
                    <div key={item.id} className="welcome-sale__list-item">
                        <PromotionItem item={item} />
                    </div>
                ))}
            </div>
        </section>
    );
}

export default WelcomePromotions;